<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">      
      <!------------------------search---------------------->
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
      	  <el-form-item style="width:10%">
      	  	  <el-select v-model="query.type" clearable @change="isselect=true">
              	  <el-option v-for="(item,index) in type" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select> 
      	  </el-form-item>
      	  <el-form-item style="width:12%">
      	  	  <el-select v-model="query.warehouse" clearable @change="isselect=true">
              	  <el-option v-for="(item,index) in wareHouseLists" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select> 
      	  </el-form-item>
          <el-form-item style="width:21%">
              <el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="isselect=true" :unlink-panels="false" style="width:100%"></el-date-picker>
          </el-form-item>
          <el-form-item ref="query" :model="query" style="width:15%">
              <el-input placeholder="订单号 / 商品名称" clearable v-model="query.key" @keyup.enter.native="getList" @change="isselect=true"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
      </el-form>
      
      <!-------------------------欠款数据列表----------------------------->
      <div class="backborder2" style="margin-top:10px">
	      <el-table :data="lists" v-loading="listLoading">
	      	  <el-table-column prop="documents" label="订单编号" min-width="120">
				  	<template slot-scope="scope">
						<span style="font-size:13px">{{scope.row.documents}}</span>
					</template>
			  </el-table-column>
	          <el-table-column prop="name" label="商品名称" min-width="120">
			  		<template slot-scope="scope">
						<span style="font-size:13px">{{scope.row.name}}</span>
					</template>
			  </el-table-column>
	          <el-table-column prop="customername" label="客户名称" min-width="120" align="center">
			  		<template slot-scope="scope">
						<span style="font-size:13px">{{scope.row.customername}}</span>
					</template>
			  </el-table-column>
	          <el-table-column prop="warehousename" label="出库仓库" min-width="120" align="center">
			  		<template slot-scope="scope">
						<span style="font-size:13px">{{scope.row.warehousename}}</span>
					</template>
			  </el-table-column>
	          <el-table-column prop="inventorys" label="仓库目前库存" min-width="120" align="center">
			  		<template slot-scope="scope">
						<span style="font-size:13px">{{scope.row.inventorys}}</span>
					</template>
			  </el-table-column>
	          <el-table-column label="待出库数量" min-width="120" align="center">
		      	  <template slot-scope="scope">
			      	  <span v-if="scope.row.issale==0" style="font-size:13px;color:#f56c6c">{{scope.row.shownum}}</span>
			      	  <span v-if="scope.row.issale==1" style="font-size:13px;color:#85ce61">{{scope.row.shownum}}</span>
		          </template>
	          </el-table-column>
	          <el-table-column prop="shownum" label="待出库数量" min-width="120" align="center" v-if="issale==1" style="color:#67c23a">
			  	  <template slot-scope="scope">
			      	  <span style="font-size:13px;color:#f56c6c">{{scope.row.shownum}}</span>
		          </template>
			  </el-table-column>
	          <el-table-column prop="inputtime" label="下单时间" align="center" min-width="120">
			  	  <template slot-scope="scope">
			      	  <span style="font-size:13px;">{{scope.row.inputtime}}</span>
		          </template>
			  </el-table-column>
	          <el-table-column label="操作" align="center" min-width="120">
		          	<template slot-scope="scope">
			            <el-button type="" size="small" round v-if="scope.row.status==2" @click="gosend(scope.row)">去发货</el-button>
			            <el-tag type="info" v-if="scope.row.status==3">已退货</el-tag>
		          	</template>
	          </el-table-column>
	      </el-table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
      </div>
      <!-------------------------欠款数据列表----------------------------->
            
  </div>
  </transition>      
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Stat/index",
      transitionshow:true,
      query: {
      	  act:'gettardylists',
      	  token:this.$cookies.get('token'),
      	  date:[],
      	  type:1,
      	  warehouse:'',
      	  key:'',
      	  p: 1,
      	  rollpage: 10,
      },
      total_rows:0,
      listLoading:false,
      lists:[],
      
      type:[
      	{id:1,name:'全部'},
      	{id:2,name:'欠货商品'},
      	{id:3,name:'退货商品'}
      ],
      
      isselect:false,
      wareHouseLists:[],
    }
  },
  
  mounted(){
    this.getList(); //获取欠货商品列表
    this.getWarehouse(); //获取仓库信息
  },
  
  methods:{
  
  	/** 获取欠货商品列表 **/
    getList(){
    	if(this.isselect==true) {
			this.query.p=1;
			this.query.rollpage=10;	    	
    	}
    
		this.listLoading = true;
	    var resource = this.$resource(this.url);
	    resource.query(this.query).then((res) => {
	        if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.listLoading = false;
		        }else{
		            this.lists = JSON.parse(Base64.decode(res.data.Data));
		            this.total_rows=parseInt(res.data.count);
		            this.listLoading = false;
	        }
	        
	        if(this.isselect==true) this.isselect=false;
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	        this.listLoading=false;
	        if(this.isselect==true) this.isselect=false;
	    });
    },
    
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    
    
    /** 去发货 **/
    gosend(item) {
    	this.$confirm('您确定要给'+item.name+'商品发货，继续?', '提示', { type: 'warning' }).then(() => {
        	// 向请求服务端删除
            var resource = this.$resource(this.url);
            resource.save({ act:'gosend',id:item.id,token:this.$cookies.get('token')}).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                	this.getList();
                    this.$message.success(''+item.name+'商品发货成功!');
                }
            }).catch((res) => {
            	//this.$message.error(this.GLOBAL.errortext);
            });
        }).catch(() => {
            //this.$message.info('已取消操作!');
        });
    },
    
    
     /** 获取仓库 **/
    getWarehouse(){
        var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
  	  
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/stat/Tardy.vue